import { types } from './types';

const initialState = {
    providers: [],
    get_provider_by_id: {},
    list: {
        data: [],
        pagination: {
            totalPage: 0,
            currentPage: 1,
            totalSize: 0,
            pageSize: 0
        }
    },
    view: {},
}

export function gamesReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_GET_PROVIDERS:
            return { ...state, providers: action.payload };
        case types.SET_GET_GAMES:
            return { ...state, list: action.payload };
        case types.SET_GET_GAME_BY_ID:
            return { ...state, view: action.payload };
        case types.SET_GET_PROVIDER_BY_ID:
            return { ...state, get_provider_by_id: action.payload };
        default:
            return state
    }
}